/**************************************************
 * Nombre:       Home_Marcas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {irUrl} from "../../../Utilidades/irUrl";
import tmp_marca from "../../../Recursos/Temporales/tmp_marca.png";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Marcas = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Splide
                    aria-label="My Favorite Images"
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        arrows: false,
                        pagination: false,
                        width: '100%',
                        drag: false,
                        interval: 5000,
                        noDrag: true,
                        type: 'loop',
                        perPage: sCell ? 3 : 7,
                        perMove: 1

                    }}
                >

                    {items.map((item, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <img
                                    onClick={() => item.url ? irUrl(item.url) : ''}
                                    src={tmp_marca} style={{width: 120, cursor: 'pointer'}}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>


        </Grid>
    )

}
export default Home_Marcas

const items = [1, 2, 3, 4, 5]